export const ENVS = {
  DEV1: 'dev1',
  DEV: 'dev',
  TEST: 'test',
  DEV_CBA: 'dev-cba',
  TEST_CBA: 'test-cba',
  PRE_PROD_CBA: 'pre-prod',
  PROD: 'prod',
};
